const NotFoundPage = () => {
  return (
    <div className='col-12 text-center p-5'>
      <h3>Lo sentimos, la página que buscás no existe!</h3>
    </div>
  );
};

export default NotFoundPage;
